export const getUserSubHistory = (globalState, product) =>
  globalState?.history?.[product] ?? [];

export const getUserId = globalState => globalState.userId;

// returns payment object
export const getUserCredit       = globalState => globalState.payment.credit;
export const getUserAch          = globalState => globalState.payment.ach;
export const getUserAchDeclined  = globalState => globalState.payment.ach.isHardDeclined;
export const getUserBtErr        = globalState => globalState.payment.hasBraintreeError;

//returns boolean
export const getUserHasCredit     = globalState => !!getUserCredit(globalState);
export const getUserHasAch        = globalState => !!getUserAch(globalState);
export const getUserAchIsDeclined = globalState => !!getUserAchDeclined(globalState);
export const getUserHasBtError    = globalState => !!getUserBtErr(globalState);
export const getUserHasPayment    = (globalState, product) =>
  product === 'billmanager'
    ? getUserHasAch(globalState)
    : getUserHasCredit(globalState);

// Survey modal state variable
export const getSurveySrc      = globalState => globalState.modal.surveySrc;
export const getProductCtx     = globalState => globalState.modal.ctx;
